import { z } from 'zod';
/**
 * URL HTTP/HTTPS pública. Rechaza:
 *   - schemes peligrosos (javascript:, data:, file:)
 *   - localhost, 127.0.0.0/8, ::1
 *   - RFC1918 (10/8, 172.16/12, 192.168/16)
 *   - link-local (169.254/16, fe80::/10)
 *
 * Defense-in-depth contra SSRF y open redirect.
 */
export const PublicHttpUrl = z
    .string()
    .url()
    .superRefine((raw, ctx) => {
    let parsed;
    try {
        parsed = new URL(raw);
    }
    catch {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'URL inválida' });
        return;
    }
    if (!['http:', 'https:'].includes(parsed.protocol)) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Solo http/https' });
        return;
    }
    const host = parsed.hostname.toLowerCase();
    if (host === 'localhost' || host === '0.0.0.0' || host === '::1' || host === '[::1]') {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Host no permitido' });
        return;
    }
    // IPv4 privado
    const m4 = host.match(/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/);
    if (m4) {
        const [a, b] = [parseInt(m4[1], 10), parseInt(m4[2], 10)];
        if (a === 10)
            return ctxBlock(ctx);
        if (a === 127)
            return ctxBlock(ctx);
        if (a === 169 && b === 254)
            return ctxBlock(ctx);
        if (a === 172 && b >= 16 && b <= 31)
            return ctxBlock(ctx);
        if (a === 192 && b === 168)
            return ctxBlock(ctx);
    }
    // IPv6 link-local
    if (host.startsWith('fe80:') || host.startsWith('[fe80:')) {
        return ctxBlock(ctx);
    }
});
function ctxBlock(ctx) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Rango de IP no permitido' });
}
